<app-tour
  tourName="dashboard"
  [autoStart]="false"
  [showButton]="false">
</app-tour>

<div class="h-full">

<div class="grid grid-cols-1 md:grid-cols-5 gap-6 p-3 md:p-6 h-full">

  <!-- Top Leads from onboarding (renders nothing when the user has none) -->
  <app-dashboard-top-leads></app-dashboard-top-leads>

  <!-- Left Side -->
  <div class="col-span-5 lg:col-span-3 bg-gray-50 dark:bg-secondary-800 rounded-xl p-3 md:p-6">

    <!-- Search Section -->
    <div class="mb-6 relative bg-white dark:bg-indigo-custom rounded-xl p-3 md:p-6">
      <h2 class="text-lg font-semibold text-secondary dark:text-white mb-2">Create new report</h2>
      <!-- Search Person -->
      <app-search-person [componentLocation]="'dashboard'" (dropdownVisibilityChanged)="onDropdownVisibility($event)"></app-search-person>
    </div>

    <div class="bg-white dark:bg-indigo-custom rounded-xl p-3 md:p-6">

      <!-- Action Buttons -->
      <div class="lg:flex lg:justify-between items-center lg:space-x-6 mb-6">

        <div class="lg:flex lg:justify-start items-center lg:space-x-6">

          <!-- See my reports -->
          <a routerLink="/reports" class="btn btn-blue w-full lg:w-auto">See my reports</a>

          <!-- Bulk upload -->
          <button type="button" (click)="openBulkUpload()" class="text-sm text-primary dark:text-primary-200 hover:opacity-90 tracking-wide hidden lg:block">
            Bulk upload
          </button>

          <!-- Toggle Camera -->
          <button type="button" (click)="toggleCamera()" class="text-sm text-gray-500 dark:text-primary-200 tracking-wide block lg:hidden">
            Toggle Camera
          </button>

        </div>

        <!--
        <div>
          <a routerLink="/market-insight" class="btn btn-blue w-full lg:w-auto">Market insight</a>
        </div>
        -->

      </div>
      <!-- / Action Buttons -->

      <hr class="border-gray-100 dark:border-secondary-800 mb-6" />

      <!-- Info -->
      <div>
        <h2 class="text-secondary dark:text-white text-lg tracking-wide font-semibold mb-4">Total reports by ICP</h2>

        <div class="grid xl:grid-cols-2 gap-6">
          <div class="flex items-center justify-between bg-gray-50 dark:bg-secondary-800 rounded-xl p-3">

            <!-- Active Reports -->
            <div class="flex items-center space-x-2">
              <h3 class="text-xl font-bold text-blue-royal">{{ activeReports }}</h3>
              <h3 class="font-medium text-secondary dark:text-primary-200">Active reports</h3>
            </div>

            <!-- Total Reports -->
            <div class="flex items-center space-x-2">
              <h3 class="font-bold text-secondary dark:text-primary-200">{{ totalReports }}</h3>
              <h3 class="font-medium text-sm text-secondary dark:text-primary-200">Total reports</h3>
            </div>

          </div>
        </div>
      </div>
      <!-- Info -->

      <!-- Charts - show if user has ICPs -->
      <div *ngIf="hasIcps && !icpsLoading" class="grid grid-cols-2 gap-6 mt-6">

        <!-- Reports by sales stage -->
        <div class="col-span-2 xl:col-span-1 border border-gray-100 dark:border-secondary-800 rounded-xl p-6">
          <h3 class="text-secondary dark:text-white text-base text-center tracking-wide font-semibold uppercase mb-3">Reports by sales stage</h3>
          <div class="w-full flex flex-col items-center">
            <div *ngIf="dashboard && dataReady" id="sales-stage-chart" class="chart"></div>
            <div *ngIf="dashboard && dataReady" id="sales-stage-legend" class="legend-horizontal dark:text-primary-200"></div>
          </div>
        </div>

        <!-- Reports by my segmentation -->
        <div class="col-span-2 xl:col-span-1 border border-gray-100 dark:border-secondary-800 rounded-xl p-6">
          <h3 class="text-secondary dark:text-white text-base text-center tracking-wide font-semibold uppercase mb-3">Reports by my segmentation</h3>
          <div class="w-full flex flex-col items-center">
            <div *ngIf="dashboard && dataReady" id="segmentation-chart" class="chart"></div>
            <div *ngIf="dashboard && dataReady" id="segmentation-legend" class="legend-horizontal dark:text-primary-200"></div>
          </div>
        </div>

      </div>
      <!-- Charts -->

    </div>

  </div>
  <!-- / Left Side -->

  <!-- Right Side -->
  <div class="col-span-5 lg:col-span-2">

    <!-- Increase ICP Score Accuracy -->
    <!-- Hidden once the ICP is fully complete (profileCompletion === 100) rather than just
         relabeled — shown while loading (profileCompletion null) so the invisible-class
         skeleton below still reserves layout space during the initial fetch. -->
    <div *ngIf="profileCompletion === null || profileCompletion < 100"
         [ngClass]="{
            'invisible': dataLoading,
            'border-red-500 dark:border-red-600': profileCompletion !== null && profileCompletion < 50,
            'border-orange-500 dark:border-orange-600': profileCompletion !== null && (profileCompletion >= 50 && profileCompletion < 100),
            'border-gray-100 dark:border-secondary-800': profileCompletion === null
         }"
         id="icp-optimization-section"
         class="border rounded-xl p-6 mb-6 bg-white dark:bg-indigo-custom">
      <!-- Show this section if user has ICPs (actual source of truth) -->
      <div *ngIf="hasIcps && !icpsLoading" class="grid grid-cols-3 items-center gap-3">

        <div class="col-span-3 xl:col-span-1">
          <div class="flex justify-center items-center h-[9rem]">
            <div *ngIf="dashboard && dataReady" id="profile-completed-chart"></div>
          </div>
          <p class="text-center text-xs text-gray-500 dark:text-primary-200 font-medium">Optimization Level</p>
        </div>

        <div class="col-span-3 xl:col-span-2">
          <!-- Show default ICP info if available -->
          <div *ngIf="defaultIcp">
            <div class="flex items-center space-x-2">
              <p class="text-xs font-medium text-gray-500 dark:text-white/75 mb-1">
                Active Default ICP: <span class="font-semibold">{{ defaultIcp.name }}</span>
              </p>
            </div>
          </div>

          <!-- Title based on profile completion percentage -->
          <!-- profileCompletion === 100 has no branch here: the whole section is *ngIf'd
               away above once complete, so that state never reaches this markup. -->
          <h2 class="text-secondary dark:text-white text-lg font-semibold mb-2">
            <ng-container *ngIf="profileCompletion !== null && profileCompletion < 50">You're missing out!</ng-container>
            <ng-container *ngIf="profileCompletion !== null && profileCompletion >= 50 && profileCompletion < 100">Almost there!</ng-container>
          </h2>

          <!-- Description based on profile completion percentage -->
          <p class="text-secondary dark:text-primary-200 text-sm mb-6">
            <ng-container *ngIf="profileCompletion !== null && profileCompletion < 50">
              Your results won't be accurate without filling in your ICP Optimization. Complete it to unlock the best results!
            </ng-container>
            <ng-container *ngIf="profileCompletion !== null && profileCompletion >= 50 && profileCompletion < 100">
              The more details you provide, the better your results. Keep going—you're on the way to getting the most of SalesOMMO.
            </ng-container>
          </p>

          <!-- Button links to edit page if user has ICPs, otherwise to create page -->
          <a *ngIf="profileCompletion !== null && icpToEdit"
             [routerLink]="['/icp/edit', icpToEdit.id]"
             class="btn btn-action"
             [ngStyle]="{'background-color': profileCompletionColor, 'border-color': profileCompletionColor}">
            Complete ICP Optimization
          </a>
          <!-- Fallback if no ICPs exist at all -->
          <a *ngIf="profileCompletion !== null && !icpToEdit"
             routerLink="/icp/create"
             class="btn btn-action"
             [ngStyle]="{'background-color': profileCompletionColor, 'border-color': profileCompletionColor}">
            Create Your First ICP
          </a>
        </div>
      </div>

      <!-- Show this section if user has NO ICPs -->
      <div *ngIf="!hasIcps && !icpsLoading">
        <div class="col-span-3 lg:col-span-2">
          <h2 class="text-secondary dark:text-white text-lg font-semibold mb-2">You're missing out!</h2>
          <p class="text-secondary dark:text-primary-200 text-md mb-6">Your results won't be accurate without filling in your ICP Optimization. Complete it to unlock the best results!</p>
          <a routerLink="/icp/create" class="btn btn-action bg-blue-royal hover:bg-blue-royal">Complete your profile</a>
        </div>
      </div>

      <!-- Loading state while checking ICPs -->
      <div *ngIf="icpsLoading" class="col-span-3 lg:col-span-2">
        <div class="flex items-center justify-center p-6">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-royal"></div>
        </div>
      </div>
    </div>
    <!-- / Increase ICP Score Accuracy -->

    <!-- Workspaces -->
    <div class="mb-6">
      <app-dashboard-workspaces></app-dashboard-workspaces>

      <a routerLink="/workspaces" class="text-sm text-primary dark:text-primary-200 hover:opacity-90 tracking-wide hidden lg:block mt-3">
        See all workspaces
      </a>

    </div>
    <!-- / Workspaces -->

    <!-- Get support from expert -->
    <div class="mb-6">
      <h2 class="text-secondary dark:text-white text-lg font-semibold mb-2">Get support from expert</h2>
      <p class="text-secondary dark:text-primary-200 text-sm mb-6">For any of the following: Installation assistance, user training, guidance to refine your target ICP for specific user, help to design a custom SalesOMMO box and General Support.</p>
      <button type="button" (click)="openRequestAssistance()" class="btn btn-blue">Request assistance</button>
    </div>
    <!-- / Get support -->

    <div class="grid grid-cols-2 gap-3 lg:divide-x divide-gray-100 dark:divide-secondary-800 bg-gray-50 dark:bg-secondary-800 rounded-xl p-6">

      <!-- Psychological Evaluation -->
      <div class="col-span-2 lg:col-span-1 mb-6 lg:mb-0 relative h-[12rem] max-h-[12rem]">
        <h2 class="text-secondary dark:text-white text-lg font-semibold mb-2">Psychological evaluation</h2>
        <p class="text-secondary dark:text-primary-200 text-sm mb-6">Improve your knowledge about your skills and become better at what you do.</p>
        <a routerLink="/psy-testing" class="xl:absolute xl:bottom-0 xl:left-0 btn btn-blue">PSY Testing</a>
      </div>

      <!-- Billing and payments -->
      <div class="col-span-2 lg:col-span-1 lg:pl-6 pb-2 md:pb-0 relative h-[12rem] max-h-[12rem]">
        <h2 class="text-secondary dark:text-white text-lg font-semibold mb-2">Billing and payments</h2>
        <p class="text-secondary dark:text-primary-200 text-sm mb-6">Check your invoice history and manage payment methods for your subscription.</p>
        <button type="button" (click)="openBillingPortal()" class="xl:absolute xl:bottom-0 xl:left-6 btn btn-blue">View Invoices</button>
      </div>

    </div>

  </div>
  <!-- / Right Side -->

</div>

</div>

<!-- Request Assistance Modal -->
<app-request-assistance
  [isVisible]="isRequestAssistanceVisible"
  (modalClosed)="onRequestAssistanceModalClosed()">
</app-request-assistance>

<app-bulk-upload [showModal]="isBulkUploadVisible" (modalClosed)="onBulkUploadModalClosed()"></app-bulk-upload>
